import { Box } from '@jfs/ui-new'
import { useEffect, useRef } from 'react'
import { Animated } from 'react-native'
import Svg, { Circle, G } from 'react-native-svg'

interface CircularProgressProps {
  children?: any
  percentage?: number
  radius?: number
  strokeWidth?: number
  duration?: number
  color?: string
  delay?: number
  textColor?: string
  max?: number
}

const AnimatedCircle = Animated.createAnimatedComponent(Circle)

const CircularProgress = ({
  children,
  percentage = 75,
  radius = 40,
  strokeWidth = 5,
  duration = 200,
  color = '#3F8C3A',
  delay = 100,
  // textColor = '#000000',
  max = 100,
}: CircularProgressProps) => {
  const animatedValue = useRef(new Animated.Value(0)).current
  const circleRef = useRef()
  const halfCircle = radius + strokeWidth
  const circleCircumference = 2 * Math.PI * radius

  const animation = (toValue: any) => {
    return Animated.timing(animatedValue, {
      toValue,
      duration,
      delay,
      useNativeDriver: true,
    }).start()
  }

  useEffect(() => {
    animation(percentage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [percentage])

  const getValue = (perc: any) => {
    const maxPerc = (100 * perc) / max
    return circleCircumference - (circleCircumference * maxPerc) / 100
  }

  const strokeDashoffset = animatedValue?.interpolate({
    inputRange: [0, percentage],
    outputRange: [getValue(0), getValue(percentage)],
  })

  return (
    <Box borderWidth={'TINY'}>
      <Svg rotation="-90" width={radius * 2} height={radius * 2} viewBox={`0 0 ${halfCircle * 2} ${halfCircle * 2}`}>
        <G origin={`${halfCircle}, ${halfCircle}`}>
          <Circle
            cx="50%"
            cy="50%"
            stroke={color}
            strokeWidth={strokeWidth}
            r={radius}
            fill={'transparent'}
            strokeOpacity={0.2}
          />
          <AnimatedCircle
            ref={circleRef}
            cx="50%"
            cy="50%"
            stroke={color}
            strokeWidth={strokeWidth}
            r={radius}
            fill={'transparent'}
            strokeDasharray={circleCircumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap={'round'}
          />
        </G>
      </Svg>
      {children}
    </Box>
  )
}

export { CircularProgress }
